import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
  label?: string;
};
export function Countdown({
  tone = 'light',
  label = 'Special offer ends in:'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const dark = tone === 'dark';
  return <div className="mt-8 text-center" role="timer" aria-label={`${label} ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-18" data-mp="3h18w0tbj847i">
      <p className={`flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wider ${dark ? 'text-ember-400' : 'text-alert-600'}`} data-id="element-19" data-mp="3259hp0xtx7tx">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="10dmtt898ht1o" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" aria-hidden="true" data-id="element-21" data-mp="15adde5k8z6ru">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-22" data-mp="xzbw3knofthc" data-mpi={i}>
            {i > 0 && <span className={`pt-4 font-display text-3xl font-black ${dark ? 'text-white/60' : 'text-navy-900/40'}`} data-id="element-23" data-mp="t1agxatdgeb5">
                :
              </span>}
            <div data-id="element-24" data-mp="12rd8d6kuhk7d">
              <div className={`flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl font-display text-4xl font-black tabular-nums sm:h-20 sm:w-20 sm:text-[2.6rem] ${dark ? 'bg-white text-navy-900' : 'bg-navy-900 text-white'}`} data-id="element-25" data-mp="12sy1qsvfax3n">
                {String(unit.value).padStart(2, '0')}
              </div>
              <p className={`mt-1.5 text-xs font-bold uppercase tracking-wider ${dark ? 'text-white/70' : 'text-navy-900/60'}`} data-id="element-26" data-mp="k0vta4sxqn4h">
                {unit.label}
              </p>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}